<template>
  <div class="flex items-center">
    <dl class="flex-grow my-0 md:flex mr-base">
      <dt
        class="mb-xs md:mb-0 font-bold text-14 text-black md:text-16 md:flex-shrink-0 md:w-{250px} flex flex-col">
        <div
          class="flex items-center"
          data-test="title"
        >
          {{ title }}
          <div data-test="title-extra">
            <slot name="title-extra" />
          </div>
        </div>
        <div
          v-if="subtitle"
          class="text-10 font-normal mt-xs text-black"
          data-test="subtitle"
        >
          {{ subtitle }}
        </div>
      </dt>
      <dd
        class="ml-0 md:ml-xl font-normal flex items-center"
        data-test="content">
        <slot name="content" />
      </dd>
    </dl>
    <div class="md:flex md:flex-wrap md:items-center md:gap-base">
      <div data-test="info" class="mb-sm md:mb-0">
        <slot name="info" />
      </div>
      <div data-test="controls">
        <slot name="controls" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SummaryItem',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
  },
};
</script>

